import posthog from 'posthog-js'

const enabled = import.meta.env.PROD

export const analytics = {
  capture(event: string, props?: Record<string, unknown>) {
    if (!enabled) return
    posthog.capture(event, props)
  },
  identify(uid: string, props: Record<string, unknown>) {
    if (!enabled) return
    posthog.identify(uid, props)
  },
  setPersonProperties(props: Record<string, unknown>) {
    if (!enabled) return
    posthog.setPersonProperties(props)
  },
  reset() {
    if (!enabled) return
    posthog.reset()
  },
}
